"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class LayoutParse {
    constructor(line, label, content) {
        this.line = line;
        this.offset = (24 - label - content) / line;
        this.label = label / line;
        this.content = 24 - this.label - this.offset;
    }
    getData(line) {
        if (!line) {
            line = this.line;
        }
        const label = this.label * line;
        const offset = this.offset * line;
        const content = 24 - label - offset;
        return {
            grid: 24 / line,
            label,
            content
        };
    }
}
exports.default = LayoutParse;
